import ScreenWrapper from "@app/hoc/ScreenWrapper";
import {ThemedText, ThemedView} from "@app/theme";
import {NativeStackScreenProps} from "@react-navigation/native-stack";
import {PrivateStackParamList} from "@routes/types";
import CommonHeader from "@sharedComponents/Header/Header";
import {IndividualStateCard} from "@screens/StateSelection/components/IndividualStateCard";
import {getStampDutyCharges, overrideStateAPICall} from "@screens/StateSelection/services/stateSelectionService";
import React, {useEffect, useState} from "react";
import PageLoader from "@app/sharedComponents/PageLoader/PageLoader";
import Button from "@sharedComponents/Button/Button";
import {useTheme} from "@shopify/restyle";
import {useAppSelector} from "@store/hooks";
import {ConfirmState} from "@screens/StateSelection/components/ConfirmState";
import {addCommasToNumber} from "@app/utils";
import {TouchableWithoutFeedback} from "react-native";

export type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'STATE_SELECTION'>;
const StateSelection = ({navigation, route}: ScreenProps) => {
    const [pageLoader, setPageLoader] = useState(false)
    const stampDutyData  = route?.params?.stampDutyData;
    const [selectedState, setSelectedState] = useState(route?.params?.stampDutyState)
    const {userDetails} = useAppSelector(state => state.auth)
    const colors = useTheme()
    const [showConfirmCard, setShowConfirmCard] = useState(false)
    const [changeState, setChangeState] = useState(false)
    const [changeStateCTALoader, setChangeStateCTALoader] = useState(false)
    const [activeTooltip, setActiveTooltip] = useState<string | null>(null);

    const handleCloseAllTooltips = () => {
        setActiveTooltip(null);
    };

    const handleStateUpdate = async() => {
        setChangeStateCTALoader(true)
        try {
            const changeStateResponse  = await overrideStateAPICall({
                applicationId: userDetails?.linkedApplications[0]?.applicationId,
                stampDutyState: selectedState
            })
            if(changeStateResponse.status === 200) {
                setShowConfirmCard(false)
                setChangeStateCTALoader(false)
                await navigation.navigate("PLEDGE_CONFIRMATION")
            }
        } catch (error) {
            setChangeStateCTALoader(false)

        }
    }


    // useEffect(() => {
    //     if(changeState) {
    //         handleStateUpdate()
    //     }
    // }, [changeState]);




    const handleStateSelectionConfirm = async () => {
        try {
            if(route?.params?.stampDutyState !== selectedState) {
                setShowConfirmCard(true)
            } else {
                setShowConfirmCard(false)
                navigation.goBack()
            }
        } catch (error) {
        }
    }


    useEffect(() => {
        setPageLoader(true)
        Promise.all([
        ]).finally(() => {
            setPageLoader(false)
        })
    }, []);


    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute: true}}>
            {pageLoader ?
            <>
                <PageLoader/>
            
            </>
                :
                <TouchableWithoutFeedback onPress={handleCloseAllTooltips}>
                    <ThemedView backgroundColor="bg-surface-primary" flex={1}>
                        <CommonHeader label="Select state" navigation={navigation} pageName={route?.name}/>
                        <ThemedView padding={"lg"}>
                            <ThemedText variant={"h3s"} color={"text-primary"}>Available states</ThemedText>
                            <ThemedText variant={"b3r"} mt={"sm"}>Select the state for stamping and registering your loan
                                agreement.</ThemedText>
                            <ThemedView mt={"lg"}>
                                {stampDutyData &&
                                    Object.keys(stampDutyData).map((item) => (
                                        <IndividualStateCard
                                            key={item}
                                            title={`${item}`}
                                            stampDutyAmount={`${addCommasToNumber(stampDutyData[`${item}`])}`}
                                            setSelectedState={setSelectedState}
                                            selected={selectedState === item}
                                            setShowStampDutyToolTip={() => {}}
                                            activeTooltip={activeTooltip}
                                            setActiveTooltip={setActiveTooltip}
                                        />
                                    ))}
                            </ThemedView>

                        </ThemedView>
                        <ThemedView justifyContent={'flex-end'} bottom={0} flex={1} mt={"sm"}>
                            <ThemedView justifyContent={"flex-end"} borderTopWidth={1} borderColor={"border-primary"}/>

                            <ThemedView padding={"lg"}>
                                <Button
                                    label="Confirm and proceed"
                                    type="SOLID"
                                    size='MD'
                                    disabled={route?.params?.stampDutyState === selectedState}
                                    handlePress={handleStateSelectionConfirm}
                                    bg={colors['bg-action-primary']}
                                    textColor={colors['text-primary']}
                                    buttonLoader={false}
                                />

                            </ThemedView>

                        </ThemedView>
                    </ThemedView>
                </TouchableWithoutFeedback>
            }

            {showConfirmCard && <ConfirmState 
                colors={colors} 
                setShowConfirmCard={setShowConfirmCard} 
                previousSelectedState={route?.params?.stampDutyState}
                previousStampDutyAmount={stampDutyData[route?.params?.stampDutyState]}
                newSelectedState={selectedState}
                newStampDutyAmount={stampDutyData[selectedState]}
                setChangeState={setChangeState}
                changeStateCTALoader={changeStateCTALoader}
                navigation={navigation}
                handleStateUpdate={handleStateUpdate}
            />}

        </ScreenWrapper>
    )
}

export default StateSelection;